<p-toast position="top-right"></p-toast>
<div class="p-g">
    <div class="p-g-12">
        <div class="card card-w-title">
            <div class="p-g">
                <div class="p-g-6">
                    <h1 style="margin-top: 0px;">{{setLabel("employeeSalaryManagementLabel")}}</h1>
                </div>
                <!-- <div class="p-g-6">
                    <button (click)="updateUserPackages()" id="enquirySave" pButton type="button" label="Update Data" icon="pi pi-save" class="ui-button-success"  style="float: right;"></button>
                </div> -->
            </div>
            <p-table [value]="users" [paginator]="true" [rows]="8" [responsive]="true" [loading]="loading"
                [first]="first" (onPage)="onPageChange($event)">

                <ng-template pTemplate="caption" style="text-align: left">

                    <input id="searchEmployee" #searchEmployee (keyup)="searchLocal(employee.name, 'name')" [(ngModel)]="employee.name"
                        style=" color: black ; height:30px ;outline: none; box-shadow: none; margin-right: 8px; width: 20%; height: 35px;"
                        autocomplete="off" pinputtext="" [placeholder]='setLabel("searchByEmployeeNamePlaceholderLabel")' type="text" name="name"
                        class="ng-pristine ng-valid ng-touched">

                    <button style="background: #ffffff; color: #0e2031; margin-right: 8px; height: 35px;" (click)="clear()"
                        class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"><i
                            class="fa fa-eraser"></i>&nbsp;{{setLabel("clearSearchLabel")}}
                    </button>

                    <button id="enquirySave" style="background: #5da30c; color: white; margin-right: 8px; height: 35px;" (click)="updateUserPackages()"
                        class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"><i
                            class="fa fa-save"></i>&nbsp;&nbsp;{{setLabel("updateDataLabel")}}
                    </button>


                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{setLabel("photoLabel")}}</th>
                        <th>{{setLabel("nameLabel")}}</th>
                        <!-- <th>Role</th> -->
                        <th>{{setLabel("phoneLabel")}}</th>
                        <th>{{setLabel("designationLabel")}}</th>
                        <!-- <th>Actions</th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-users>
                    <tr>
                        <td>
                            &nbsp;&nbsp;&nbsp;
                            <a (click)="openPhoto(users.profile)">
                                <img [alt]="" src="{{users.profile}}" onerror="this.onerror=null;this.src=`assets/layout/images/avatarBoyImage.png`;" width="60" style="vertical-align: middle" />
                            </a>
                        </td>
                        <td>{{users.name}}</td>
                        <!-- <td>{{users.userRole.name}}</td> -->
                        <td>{{users.phone}}</td>
                        <td>
                            <p-dropdown [options]="allDesignationDd" name="Currency" id="designation" #designation [style]="{'width':'70%'}" [(ngModel)]="users.designation"></p-dropdown>
                        </td>
                        <!-- <td>
                            <button pButton type="button" pTooltip="Remove Designation" (click)="deleteDesignation(users._id)" class="ui-button-danger ui-button" icon="fa fa-times"></button>
                        </td> -->
                    </tr>
                </ng-template>
            </p-table>
            <div *ngIf="imgPreview" (click)="closePhotoPreview()"
                style="position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999999; display: flex; align-items: center; justify-content: center; background: #000000cf;">
                <svg (click)="closePhotoPreview()"
                    style="width: 20px; position: absolute; top: 30px; right: 40px; color: #fff; cursor: pointer;"
                    aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
                    class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 352 512">
                    <path fill="currentColor"
                        d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                    </path>
                </svg>
                <img src="{{imgPreviewImg}}" onerror="this.onerror=null;this.src=`assets/layout/images/avatarBoyImage.png`;"
                 style="width: 25vw; height: auto;background: #fff;" />
            </div>
        </div>
    </div>
</div>
